export const roomStartAt = {
  type: "number",
  minimum: 0,
  maximum: Number.MAX_SAFE_INTEGER
};
